import { FormControlLabel, Grid } from '@mui/material';
import { BoardType, ParamsPanelProps } from 'Types';

import MaterialPatternInput from 'designer/MaterialPatternInput';
import NumberInput from 'designer/NumberInput';
import Switch from 'designer/Switch';
import { useSelectedBoardStep } from 'utils/hooks';

function StripsParamsPanel(props: ParamsPanelProps<BoardType.Strips>) {
  const { onParamChange, onSelectionChange, params, selection, units } = props;
  const step = useSelectedBoardStep();

  return (
    <Grid container direction="column" spacing={2}>
      <Grid container item spacing={2}>
        <Grid item xs={4}>
          <NumberInput
            id="row-height"
            label="Row Height"
            step={step}
            value={params.rowHeight}
            onChange={onParamChange('rowHeight')}
          />
        </Grid>
        <Grid item xs={4}>
          <NumberInput
            id="number-of-rows"
            label="# of Rows"
            value={params.numRows}
            onChange={onParamChange('numRows')}
          />
        </Grid>
        <Grid item xs={4}>
          <NumberInput
            id="thickness"
            label="Thickness"
            step={step}
            value={params.thickness}
            onChange={onParamChange('thickness')}
          />
        </Grid>
      </Grid>

      <Grid item>
        <MaterialPatternInput
          id="pattern"
          onChange={onParamChange('pattern')}
          onSelectionChange={onSelectionChange}
          previewHeight={params.rowHeight}
          selection={selection}
          units={units}
          value={params.pattern}
        ></MaterialPatternInput>
      </Grid>

      <Grid item>
        <FormControlLabel
          control={
            <Switch onChange={onParamChange('flip')} value={params.flip} />
          }
          label="Flip Alternating Rows"
        />
      </Grid>
    </Grid>
  );
}

export default StripsParamsPanel;
